(function (window, $, Argument, RecurringTimer, app) {
    var Math = window.Math;
    var parseFloat = window.parseFloat;
    var repaint;

    function Slider() {
        var _this = this;
        var sliders = {};
        var fn = {};
        var sliderSelector = '.slider';

        var defaults = {
            autoplay: true,
            interval: 5000,
            hover: 'pause',
            sliderPlayingClass: '--is-playing',
            onSlide: false,
            onPlay: false,
            onPause: false
        };

        fn.getRelatedSlider = function ($el) {
            var id = $el.attr('id');

            return $(sliderSelector).filter('[data-rel="#' + id + '"]');
        };

        fn.getSlides = function ($el) {
            return $el.find('.slider\\/slide');
        };

        fn.getControlContainer = function ($el) {
            return $el.find('.slider\\/controls');
        };

        fn.getControls = function ($el) {
            return $el.find('.slider\\/control');
        };

        fn.emit = function (id, event, args) {
            args = Argument.get(args, []);

            var slider = sliders[id];
            var callbacks = slider.events[event];

            args.unshift(id);

            for (var i = 0; i < callbacks.length; i++) {
                var callback = callbacks[i];

                callback.apply(_this, args);
            }
        };

        fn.slideTo = function (id, to, dir) {
            var slider = sliders[id];
            var current = _this.getCurrentSlide(id);
            var total = _this.getTotalSlides(id);

            if (to < 0) {
                to = total - 1;
            } else if (to >= total) {
                to = 0;
            }

            if (current == to) {
                return fn.resolveQueue(id);
            }

            slider.current = to;
            slider.animating = true;

            var $current = slider.slides.filter('.\\--active');
            var $target = $(slider.slides[to]);

            fn.emit(id, 'slide', [$target, $current, dir]);

            $target.addClass('--' + (dir == 'left' ? 'right' : 'left'));
            repaint = $target[0].offsetWidth;

            var dCurrent = $.Deferred();
            var dTarget = $.Deferred();

            $target.addClass('--active').removeClass('--left --right').on(app.transitionEvent(), function () {
                $target.off(app.transitionEvent());

                if (app.supports('csstransitions')) {
                    dTarget.resolve();
                }
            });

            $current.addClass('--out').removeClass('--active --left --right').addClass('--' + dir).on(app.transitionEvent(), function () {
                $current.off(app.transitionEvent());
                $current.removeClass('--out --left --right');

                if (app.supports('csstransitions')) {
                    dCurrent.resolve();
                }
            });

            if (app.rejects('csstransitions')) {
                window.setTimeout(function () {
                    $current.removeClass('--out --left --right');

                    dTarget.resolve();
                    dCurrent.resolve();
                }, app.ANIMATION_DURATION);
            }

            $.when(dCurrent, dTarget).done(function () {
                slider.animating = false;
                fn.resolveQueue(id);
            });

            var $related = fn.getRelatedSlider(slider.el);

            if ($related.length) {
                var $slides = fn.getSlides($related);
                var $currentRelated = $slides.filter('.\\--active');
                var $targetRelated = $($slides[to]);

                $targetRelated.removeClass('--out --left --right').addClass('--' + (dir == 'left' ? 'right' : 'left'));
                repaint = $targetRelated[0].offsetWidth;
                $targetRelated.addClass('--active');
                $currentRelated.addClass('--out').removeClass('--active --left --right').addClass('--' + dir).on(app.transitionEvent(), function () {
                    $currentRelated.off(app.transitionEvent());
                    $currentRelated.removeClass('--out --left --right');
                });

                if (app.rejects('csstransitions')) {
                    window.setTimeout(function () {
                        $currentRelated.removeClass('--out --left --right');
                    }, app.ANIMATION_DURATION);
                }
            }
        };

        fn.resolveQueue = function (id) {
            var slider = sliders[id];
            var queue = slider.queue;

            if (slider.animating) {
                return;
            }

            if (! queue.length) {
                return (slider.animating = false);
            }

            fn.triggerAction(queue.shift());
        };

        fn.next = function (id) {
            var current = _this.getCurrentSlide(id);
            var total = _this.getTotalSlides(id);
            var to = current + 1;

            fn.slideTo(id, to, 'left');
        };

        fn.triggerAction = function (action) {
            var id = action.slider;
            var current = _this.getCurrentSlide(id);
            var slider = sliders[id];

            slider.timer.clear();

            switch (action.name) {
                case 'slide':
                    fn.slideTo(id, action.to, current < action.to ? 'left' : 'right');
                    break;
                case 'slideDir':
                    fn.slideTo(id, action.to, action.dir);
                    break;
                case 'next':
                    fn.slideTo(id, current + 1, 'left');
                    break;
                case 'prev':
                    fn.slideTo(id, current - 1, 'right');
                    break;
            }

            if (slider.playing) {
                _this.play(id);
            }
        };

        fn.uiSlide = function (id, actionName, to, dir) {
            var slider = sliders[id];
            var action = {
                slider: id,
                name: actionName,
                to: to,
                dir: dir
            };

            if (slider.animating) {
                return slider.queue.push(action);
            }

            fn.triggerAction(action);
        };

        this.config = function (opts) {
            defaults = $.extend({}, defaults, opts);
        };

        this.init = function ($el, opts) {
            opts = Argument.get(opts, {});

            var id = $el.attr('id');
            var options = $.extend({}, defaults, opts);
            var $slides = fn.getSlides($el);
            var $controlContainer = fn.getControlContainer($el);
            var $controls = fn.getControls($el);

            var nextSlide = function () {
                fn.next(id);
            };

            var containerWidth = $el.width();
            var slideWidth = $slides.outerWidth(true);
            var relativeSlideWidth = Math.round((slideWidth / containerWidth) * 100);

            var transitionDuration = parseFloat($slides.css('transition-duration')) * 1000;

            if (app.rejects('csstransitions')) {
                transitionDuration = app.ANIMATION_DURATION;
            }

            sliders[id] = {
                id: id,
                el: $el,
                current: 0,
                slides: $slides,
                slideWidth: relativeSlideWidth,
                total: $slides.length,
                playing: false,
                animating: false,
                queue: [],
                events: {
                    slide: [],
                    play: [],
                    pause: []
                },
                timer: new RecurringTimer(options.interval + transitionDuration, nextSlide),
                options: options,
            };

            var slider = sliders[id];

            if (slider.options.onSlide) {
                this.onSlide(id, slider.options.onSlide);
            }

            if (slider.options.onPlay) {
                this.onPlay(id, slider.options.onPlay);
            }

            if (slider.options.onPause) {
                this.onPause(id, slider.options.onPause);
            }

            this.onPlay(id, function () {
                if ($controlContainer.length) {
                    $controlContainer.addClass(options.sliderPlayingClass);
                }
            });

            this.onPause(id, function () {
                if ($controlContainer.length) {
                    $controlContainer.removeClass(options.sliderPlayingClass);
                }
            });

            if (options.hover === 'pause') {
                $el.hover(function () {
                    slider.hover = false;

                    if (slider.playing) {
                        slider.timer.pause();
                        slider.hover = 'paused';
                    }
                }, function () {
                    if (slider.hover === 'paused') {
                        slider.timer.play();
                        slider.hover = false;
                    }
                });
            }

            if (slider.options.autoplay) {
                this.play(id);
            }
        };

        this.getSliders = function () {
            return sliders;
        };

        this.play = function (id) {
            var slider = sliders[id];

            slider.timer.play();
            slider.playing = true;

            fn.emit(id, 'play');
        };

        this.onPlay = function (id, callback) {
            var slider = sliders[id];

            slider.events.play.push(callback);
        };

        this.pause = function (id) {
            var slider = sliders[id];

            slider.timer.pause();
            slider.playing = false;

            fn.emit(id, 'pause');
        };

        this.onPause = function (id, callback) {
            var slider = sliders[id];

            slider.events.pause.push(callback);
        };

        this.togglePlaying = function (id) {
            var slider = sliders[id];

            if (slider.playing) {
                this.pause(id);
            } else {
                this.play(id);
            }
        };

        this.getSlider = function (id) {
            return sliders[id];
        };

        this.getCurrentSlide = function (id) {
            return sliders[id].current;
        };

        this.getTotalSlides = function (id) {
            return sliders[id].total;
        };

        this.slideTo = function (id, to, dir) {
            var current = this.getCurrentSlide(id);

            if (current == to) {
                return;
            }

            fn.uiSlide(id, 'slide', to);
        };

        this.slideToDir = function (id, to, dir) {
            var current = this.getCurrentSlide(id);

            if (current == to) {
                return;
            }

            fn.uiSlide(id, 'slideDir', to, dir);
        };

        this.onSlide = function (id, callback) {
            var slider = sliders[id];

            slider.events.slide.push(callback);
        };

        this.prev = function (id) {
            fn.uiSlide(id, 'prev');
        };

        this.next = function (id) {
            fn.uiSlide(id, 'next');
        };
    }

    app.Slider = new Slider();
})(window, jQuery, Argument, RecurringTimer, Template3);
